import React from "react";
import PicturesShell from "../PicturesShell";
import { isInsufficientCreditMessage } from "../../utils/uploadError";
import "./style.css";

export default function UploadErrorScreen({
  message,
  onRetry,
  onClose,
}) {
  const text =
    (message && String(message).trim()) ||
    "Photo upload failed. Please try again.";
  const isCredits = isInsufficientCreditMessage(text);

  return (
    <PicturesShell
      mainClassName="pi-pictures-main--center pi-pictures-main--status"
      badge={isCredits ? "Credits" : "Upload error"}
      showFooter={false}
    >
      <div
        className="pi-pictures-status-card pi-pictures-status-card--premium pi-upload-error"
        role="alert"
      >
        <span className="pi-pictures-label">
          {isCredits ? "Insufficient credits" : "Upload failed"}
        </span>
        <div className="pi-upload-error__icon" aria-hidden>
          {isCredits ? "💳" : "⚠️"}
        </div>
        <h1>
          {isCredits
            ? "Not enough credits"
            : "We could not save this photo"}
        </h1>
        <div className="pi-upload-error__reason">
          <span className="pi-upload-error__reason-label">Why it failed</span>
          <p className="pi-upload-error__reason-text">{text}</p>
        </div>
        <div className="pi-upload-error__actions">
          {onRetry && !isCredits ? (
            <button
              type="button"
              className="pi-upload-error__btn pi-upload-error__btn--primary"
              onClick={onRetry}
            >
              Try again
            </button>
          ) : null}
          {onClose ? (
            <button
              type="button"
              className={`pi-upload-error__btn${
                isCredits || !onRetry
                  ? " pi-upload-error__btn--primary"
                  : " pi-upload-error__btn--ghost"
              }`}
              onClick={onClose}
            >
              {isCredits ? "Close" : "Back"}
            </button>
          ) : null}
        </div>
      </div>
    </PicturesShell>
  );
}
